import { Box, BoxProps, ColorOptions, LoaderNew, Spacer, TextNew, TextNewProps } from '@jfs/ui-new'
import { colors } from '../../util/colors'

export const FallbackScreen = () => {
  return (
    <Box {...style.mainViewWrap}>
      <LoaderNew color={colors.BUTTON_BLUE as ColorOptions} />
      <Spacer size={12} />
      <TextNew {...style.loadingText}>{'Loading'}</TextNew>
    </Box>
  )
}

const style = {
  mainViewWrap: {
    f: 1,
    h: '100vh',
    backgroundColor: 'WHITE',
    justify: 'center',
  } as BoxProps,
  loadingText: {
    type: 'bodyMedium14',
    textAlign: 'center',
    color: colors.BUTTON_BLUE as ColorOptions,
  } as TextNewProps,
}
